export default {
  duration: (state) => {
    return state.duration;
  },
};
